// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1V8NS","dragIcon":"SortableItem_dragIcon__Q1x4c","disabled":"SortableItem_disabled__27ga8"};